import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http:HttpClient,
    private router: Router) { }

  login(authData: any){
    return this.http.post( DATOS_API.url + DATOS_API.endpoints.login, authData);

  }
}
